var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"basketball_lineupData"}},[_c('span',{staticClass:"dev"},[_vm._v("待完善")])])
}]

export { render, staticRenderFns }